var _rect, _rect2, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 157,
    viewBox: "0 0 234 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 233.6,
    height: 157,
    fill: "#FAFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.4107,
    y: 57.2857,
    width: 59.4286,
    height: 43.4286,
    rx: 5.07857,
    stroke: "#E5ECF6",
    strokeWidth: 3.42857,
    strokeMiterlimit: 16,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.423 74.6133L93.6341 92.042C92.645 93.2077 93.4734 94.9972 95.0022 94.9972H124.58C126.109 94.9972 126.937 93.2077 125.948 92.042L111.159 74.6133C110.443 73.7688 109.14 73.7688 108.423 74.6133Z",
    fill: "#E5ECF6",
    stroke: "#E5ECF6",
    strokeWidth: 2.01857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.008 81.2725L120.086 92.0626C119.118 93.2325 119.95 95.0003 121.469 95.0003H139.314C140.832 95.0003 141.664 93.2325 140.697 92.0626L131.774 81.2725C131.056 80.4047 129.726 80.4047 129.008 81.2725Z",
    fill: "#E5ECF6",
    stroke: "#E5ECF6",
    strokeWidth: 2.01857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.347,
    cy: 69.0005,
    r: 4,
    fill: "#E5ECF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCompany);
export default __webpack_public_path__ + "static/media/avatar-company.3328979519a311df77905dc2b44ef967.svg";
export { ForwardRef as ReactComponent };